module.exports = __webpack_public_path__ + "img/hnfnu-logo.2ed5816b.png";